import { Link, Text } from "@chakra-ui/react"
import React from "react"
import { isDefaultLang } from "../utils/i18nHelpers"

const Withdrawal = ({ pageContext }) => {
  const language = pageContext.language
  const isEnglish = isDefaultLang(language)
  if (language === "en") {
    return (
      <Link
        href={
          "mailto:info@christian-metzner.com?subject=Withdrawal%20request&body=Order%20number:%0APlease%20describe%20the%20items%20you%20wish%20to%20return:"
        }
        isExternal
      >
        <Text as={"span"} size={"sm"} variant={"uppercase"} mb={0}>
          {"Withdrawal Request"}
        </Text>
      </Link>
    )
  } else {
    return (
      <Link
        href={
          "mailto:info@christian-metzner.com?subject=Widerrufsantrag&body=Bestellnummer:%0A%0ABitte%20beschreiben%20Sie%20die%20Artikel,%20die%20Sie%20zur%C3%BCckgeben%20m%C3%B6chten:"
        }
        isExternal
      >
        <Text as={"span"} size={"sm"} variant={"uppercase"} mb={0}>
          {"Widerrufsantrag"}
        </Text>
      </Link>
    )
  }
}

export default Withdrawal
